import { render, staticRenderFns } from "./SaveFiltersIcon.vue?vue&type=template&id=13825c08&scoped=true"
import script from "./SaveFiltersIcon.vue?vue&type=script&lang=js"
export * from "./SaveFiltersIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13825c08",
  null
  
)

export default component.exports